import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientESSForm() {
    return (
        <PatientFormTemplate formTitle="Epworth Sleepiness Scale (ESS)" />
    );
}
